import { render, staticRenderFns } from "./ProductTourStep.vue?vue&type=template&id=3318e0f6"
import script from "./ProductTourStep.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductTourStep.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports